import { downgradeComponent, downgradeInjectable } from '@angular/upgrade/static';
import { TenancyEmailComponent } from '@app/tenancy/email/components';
import { EmailService } from '@app/tenancy/email/services';

export function TenancyDowngrader(app: any) {
   app.factory(EmailService.injectName, downgradeInjectable(EmailService));
   app.directive('amTenancyEmail', downgradeComponent({
      component: TenancyEmailComponent
   }));
}